export const WEBSITE_DRAFT_DELETE_REASONS = Object.freeze([
  "I no longer need this website.",
  "I built it for the wrong listing.",
  "The imported content does not look right.",
  "I want to try a different template.",
  "I prefer to manage bookings without a direct booking website.",
  "Other",
]);
